import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import InfiniteScroll from "react-infinite-scroller";
import * as matchesActions from "../../_actions/matchesActions";
import UserWidgetContainer from "../Matches/UserWidgetContainer";
import Section from "../UI/Section";
import PageSubTitle from "../UI/PageSubTitle";
import getProfileVisitors from "../../_selectors/matchesSelectors/getProfileVisitors";
import getMatchesLastResult from "../../_selectors/matchesSelectors/getMatchesLastResult";
import { updateObject } from "../../_utils";
import matchesConstants from "../../_constants/matchesConstants";
import getMyProfileVisitorsCount from "../../_selectors/userSelectors/getMyProfileVisitorsCount";
class ProfileVisitors extends Component {
  componentDidMount() {
    const {
      updateHeader,
      updateBreadcrumb,
      getVisitors,
      visitorsCount,
      markAllAsRead
    } = this.props;
    updateHeader({
      title: "Profile Visitors",
      description: "Members who viewed your profile "
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Profile Visitors", link: "/search" }
    ]);
    getVisitors();
    if (visitorsCount > 0) {
      markAllAsRead();
    }
  }
  componentWillUnmount() {
    const { clearMembers, clearVisitors } = this.props;
    clearMembers();
    clearVisitors();
  }
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;

    loadMore({ lastResult });
  };
  render() {
    const { results, lastResult } = this.props;
    return (
      <Section>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMoreItems}
          hasMore={lastResult !== null}
          initialLoad={false}
          loader={
            <div
              className="loader"
              style={{
                height: "50px",
                background: "#4d4d4d",
                textAlign: "center",
                lineHeight: "50px",
                color: "#fff",
                fontSize: "1.5em",
                marginTop: "1em"
              }}
            >
              Please Wait
            </div>
          }
        >
          <div className="row">
            {results.length === 0 ? (
              <PageSubTitle center>
                <h3>No Members</h3>
              </PageSubTitle>
            ) : (
              map(results, result => (
                <div key={result.id} className="col-md-4">
                  <UserWidgetContainer user={result.viewerId} />
                </div>
              ))
            )}
          </div>
        </InfiniteScroll>
      </Section>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: getProfileVisitors(state),
  lastResult: getMatchesLastResult(state),
  visitorsCount: getMyProfileVisitorsCount(state)
});

const mapDispatchToProps = dispatch => ({
  getVisitors: () => dispatch(matchesActions.getProfileVisitors()),
  clearMembers: () => dispatch(matchesActions.clearMatchedMembers()),
  clearVisitors: () => dispatch(matchesActions.clearProfileVisitors()),
  loadMore: payload =>
    dispatch(
      matchesActions.loadMoreSearchResults(
        updateObject(payload, { type: matchesConstants.GET_PROFILE_VISITORS })
      )
    ),
  markAllAsRead: () => dispatch(matchesActions.markAllProfileVisitorsAsRead())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileVisitors);



// WEBPACK FOOTER //
// ./src/_components/ProfileVisitors/index.js